module.exports = __webpack_public_path__ + "img/verificationReportBg1.a8ba1190.png";